module.exports = __webpack_public_path__ + "img/81.b7ae6c3b.jpg";